<template>
  <v-container>
    <v-layout justify-center column>
      <v-flex xs12>
        <h1 class="display-1 mt-4 mb-1 text-xs-center">
          Personalized Search Results
        </h1>
        <p class="subheading text-xs-center font-italic grey--text mb-0">
          This information is believed to be accurate, but without warranty.
        </p>
      </v-flex>
      <v-container grid-list-xl mt-4>
        <v-layout row wrap>
          <template v-if="search.length">
            <listing-card
              v-for="listing in search"
              :key="listing.mlsId"
              :listing="listing"
            ></listing-card>
          </template>
          <v-flex
            v-else
            class="flex pt-3 xs12 sm12 lg10 offset-lg1 xl8 offset-xl2"
          >
            <v-alert
              :value="true"
              color="info"
              icon="fas fa-info-circle"
              outline
            >
              Sorry, no properties with your search terms were found
            </v-alert>
            <v-btn color="primary" large class="mt-4" @click="$router.go(-1)">
              Go Back
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import ListingCard from '../components/ListingCard';

export default {
  name: 'Results',
  metaInfo: {
    title: 'Search Results',
  },
  components: {
    ListingCard,
  },
  computed: {
    ...mapGetters({
      search: 'search',
    }),
  },
};
</script>
